import React from 'react';
import { Col, Button, Modal } from 'react-bootstrap';

const SubscriptionModal = props => (
  <Modal show={props.show} className="modal-pass want-unsubscribe">
    <span className="litpog-remove" onClick={props.onHide} />
    <Col md={12} className="main-old-pass">
      <Modal.Header className="old-pass">
        <Modal.Title>{props.text}</Modal.Title>
      </Modal.Header>
    </Col>
    <Col md={12}>
      <Modal.Body>{props.children || ''}</Modal.Body>
    </Col>
    {!props.hideButtons && (
      <Col md={12}>
        <Modal.Footer className="footer-ok-buttons">
          {props.handleSubscriptionAction && (
            <Button className="buttons-ok" onClick={props.handleSubscriptionAction}>
              <span className="buttons-ok-text">Yes</span>
            </Button>
          )}
          <Button className="buttons-ok" onClick={props.onHide}>
            <span className="buttons-ok-text">{props.cancelButtonText || 'Cancel'}</span>
          </Button>
        </Modal.Footer>
      </Col>
    )}
  </Modal>
);

export default SubscriptionModal;



// WEBPACK FOOTER //
// ./src/components/Dashboard/Profile/SubscriptionModal.js